import { useEffect } from 'react';

export function useAccessibility() {
  useEffect(() => {
    // Add keyboard navigation listeners
    const handleKeyDown = (e: KeyboardEvent) => {
      // Skip to main content with Alt+S (common accessibility pattern)
      if (e.altKey && e.key === 's') {
        e.preventDefault();
        const main = document.querySelector('main') || document.querySelector('#main-content');
        if (main) {
          (main as HTMLElement).focus();
          main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Announce page changes to screen readers
    const handleRouteChange = () => {
      const announcement = document.createElement('div');
      announcement.setAttribute('role', 'status');
      announcement.setAttribute('aria-live', 'polite');
      announcement.className = 'sr-only';
      announcement.textContent = 'Page content loaded';
      document.body.appendChild(announcement);
      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    };

    // Trigger announcement on mount
    handleRouteChange();

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}

// Screen reader only class helper
export const announceToScreenReader = (message: string) => {
  const announcement = document.createElement('div');
  announcement.setAttribute('role', 'status');
  announcement.setAttribute('aria-live', 'polite');
  announcement.className = 'sr-only';
  announcement.textContent = message;
  document.body.appendChild(announcement);
  setTimeout(() => {
    if (document.body.contains(announcement)) {
      document.body.removeChild(announcement);
    }
  }, 1000);
};

